module.exports = __webpack_public_path__ + "static/media/8.07574efa.png";